// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import APIURL from "../../common/Config";
// import { encodeRequestData } from '../../utils/apiSecurity';
// import toast from 'react-hot-toast';
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = () => {
//   const navigate = useNavigate();
//   const phone = localStorage.getItem('phoneNumber');
//   const email = localStorage.getItem('userEmail');
//   const isEmail = !!email;
//   const [otp, setOtp] = useState(isEmail ? ['', '', '', '', '', ''] : ['', '', '', '']);
//   const inputRefs = useRef([]);

//   const handleVerify = async () => {
//     const code = otp.join('');
//     try {
//       if (isEmail) {
//         await axios.post(`${APIURL}/astroservice/otp/verify-email?email=${email}&otp=${code}`);
//         localStorage.setItem("isEmailVerified", "true");
//       } else {
//         const payload = encodeRequestData({ requestType: 'VALIDATE-OTP', msisdn: phone, otpPin: code, otpSessionId: localStorage.getItem('otpSessionId') });
//         await axios.post(`${APIURL}/otp/service`, payload);
//         localStorage.setItem("isOtpVerified", "true");
//       }
//       navigate("/signup-who-are-you");
//     } catch (e) { toast.error("Invalid OTP"); }
//   };

//   return (
//     <div className="otp-page-bg">
//       <div className="otp-card-v2">
//         <h2>Verify {isEmail ? "Email" : "Mobile"}</h2>
//         <p>OTP sent to {isEmail ? email : phone}</p>
//         <div className="otp-box-grid">
//           {otp.map((d, i) => (
//             <input key={i} ref={el => inputRefs.current[i] = el} maxLength={1} value={d}
//               onChange={e => {
//                 const n = [...otp]; n[i] = e.target.value; setOtp(n);
//                 if (e.target.value && i < otp.length - 1) inputRefs.current[i+1].focus();
//               }} />
//           ))}
//         </div>
//         <button className="otp-submit-btn" onClick={handleVerify}>VERIFY</button>
//       </div>
//     </div>
//   );
// };
// export default UnifiedOtpValidate;
// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import APIURL from "../../common/Config";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const phone = localStorage.getItem("phoneNumber");
//   const email = localStorage.getItem("userEmail");
//   const isEmail = location.state?.flow === "email";
//   const [otp, setOtp] = useState(
//     isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""],
//   );
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     inputRefs.current[0]?.focus();
//   }, []);

//   // const handleVerify = async () => {
//   //   const code = otp.join("");
//   //   try {
//   //     if (isEmail) {
//   //       const res = await axios.post(
//   //         `${APIURL}/astroservice/otp/verify-email?email=${email}&otp=${code}`,
//   //       );
//   //       if (res.data.success) {
//   //         localStorage.setItem("isEmailVerified", "true");
//   //         navigate("/signup-who-are-you");
//   //       } else {
//   //         toast.error("Invalid OTP");
//   //       }
//   //     } else {
//   //       const payload = encodeRequestData({
//   //         requestType: "VALIDATE-OTP",
//   //         msisdn: phone,
//   //         otpPin: code,
//   //         otpSessionId: localStorage.getItem("otpSessionId"),
//   //       });
//   //       const res = await axios.post(`${APIURL}/otp/service`, payload);
//   //       if (res.data.status === "SUCCESS") {
//   //         localStorage.setItem("isOtpVerified", "true");
//   //         navigate("/signup-who-are-you");
//   //       } else {
//   //         toast.error("Invalid OTP");
//   //       }
//   //     }
//   //   } catch (e) {
//   //     toast.error("Error");
//   //   }
//   // };


//   const handleVerify = async () => {
//   const code = otp.join("");
//   if(code.length < (isEmail ? 6 : 4)) return toast.error("Enter full OTP");

//   try {
//     if (isEmail) {
//       // EXACT VERIFY API FROM YOUR CURL
//       const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${email}&otp=${code}`);
//       if (res.data.success === "OTP verified successfully.") {
//         localStorage.setItem("isEmailVerified", "true");
//         toast.success("Email Verified");
//         navigate("/signup-who-are-you");
//       } else {
//         toast.error("Invalid Email OTP");
//       }
//     } else {
//       // Mobile Verification Logic (Existing)
//       const payload = encodeRequestData({
//         requestType: "VALIDATE-OTP",
//         msisdn: phone,
//         otpPin: code,
//         otpSessionId: localStorage.getItem("otpSessionId"),
//       });
//       const res = await axios.post(`${APIURL}/otp/service`, payload);
//       if (res.data.status === "SUCCESS") {
//         localStorage.setItem("isOtpVerified", "true");
//         navigate("/signup-who-are-you");
//       } else {
//         toast.error("Invalid Mobile OTP");
//       }
//     }
//   } catch (e) {
//     toast.error("Verification failed");
//   }
// };


//   return (
//     <div className="unified-otp-bg">
//       <div className="otp-modern-card">
//         <h2>Verify Identity</h2>
//         <p>Sent to: {isEmail ? email : phone}</p>
//         <div className="otp-row">
//           {otp.map((d, i) => (
//             <input
//               key={i}
//               ref={(el) => (inputRefs.current[i] = el)}
//               maxLength={1}
//               value={d}
//               onChange={(e) => {
//                 const n = [...otp];
//                 n[i] = e.target.value;
//                 setOtp(n);
//                 if (e.target.value && i < otp.length - 1)
//                   inputRefs.current[i + 1].focus();
//               }}
//             />
//           ))}
//         </div>
//         <button className="otp-submit-btn" onClick={handleVerify}>
//           VERIFY OTP
//         </button>
//       </div>
//     </div>
//   );
// };
// export default UnifiedOtpValidate;



// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import APIURL from "../../common/Config";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import Header from "../header/header";
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const phone = localStorage.getItem("phoneNumber");
//   const email = localStorage.getItem("userEmail");
//   const isEmail = location.state?.flow === "email";
//   const [otp, setOtp] = useState(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     inputRefs.current[0]?.focus();
//   }, []);

//   const handleVerify = async () => {
//     const code = otp.join("");
//     if (code.length < (isEmail ? 6 : 4)) return toast.error("Please enter full OTP");

//     try {
//       if (isEmail) {
//         const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${email}&otp=${code}`);
//         if (res.data.success === "OTP verified successfully.") {
//           localStorage.setItem("isEmailVerified", "true");
//           toast.success("Email Verified Successfully");
//           navigate("/signup-who-are-you");
//         } else {
//           toast.error("Invalid Email OTP");
//         }
//       } else {
//         const payload = encodeRequestData({
//           requestType: "VALIDATE-OTP",
//           msisdn: phone,
//           otpPin: code,
//           otpSessionId: localStorage.getItem("otpSessionId"),
//         });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         if (res.data.status === "SUCCESS") {
//           localStorage.setItem("isOtpVerified", "true");
//           toast.success("Mobile Verified Successfully");
//           navigate("/signup-who-are-you");
//         } else {
//           toast.error("Invalid Mobile OTP");
//         }
//       }
//     } catch (e) {
//       toast.error("Verification failed. Please try again.");
//     }
//   };

//   return (
//     <div className="unified-page-wrapper">
//       <Header />
//       <div className="unified-otp-bg">
//         <div className="otp-modern-card">
//           <div className="ab-logo-universe-box">
//             <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
//             <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
//           </div>
//           <h2>Verify Identity</h2>
//           <p className="otp-sent-to">OTP sent to: <span>{isEmail ? email : `+91 ${phone}`}</span></p>
//           <div className="otp-row">
//             {otp.map((d, i) => (
//               <input
//                 key={i}
//                 ref={(el) => (inputRefs.current[i] = el)}
//                 maxLength={1}
//                 type="text"
//                 inputMode="numeric"
//                 value={d}
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/[^0-9]/g, "");
//                   if (!val && e.nativeEvent.inputType !== "deleteContentBackward") return;
//                   const n = [...otp];
//                   n[i] = val;
//                   setOtp(n);
//                   if (val && i < otp.length - 1) inputRefs.current[i + 1].focus();
//                 }}
//                 onKeyDown={(e) => {
//                   if (e.key === "Backspace" && !otp[i] && i > 0) inputRefs.current[i - 1].focus();
//                 }}
//               />
//             ))}
//           </div>
//           <button className="otp-submit-btn" onClick={handleVerify}>VERIFY OTP</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnifiedOtpValidate;


// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import APIURL from "../../common/Config";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import Header from "../header/header";
// import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const phone = localStorage.getItem("phoneNumber");
//   const email = localStorage.getItem("userEmail");
//   const isEmail = location.state?.flow === "email";
//   const [otp, setOtp] = useState(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     inputRefs.current[0]?.focus();
//   }, []);

//   const checkUserAndNavigate = async (identity) => {
//     try {
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(identity);
//       if (data && data.id > 0) {
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("userData", JSON.stringify(data));
//         toast.success("Welcome back!");
//         navigate("/");
//       } else {
//         // Naya user hai, selection screen par bhejo jo popup open karega
//         navigate("/signup-who-are-you");
//       }
//     } catch (e) {
//       navigate("/signup-who-are-you");
//     }
//   };

//   const handleVerify = async () => {
//     const code = otp.join("");
//     if (code.length < (isEmail ? 6 : 4)) return toast.error("Enter full OTP");

//     try {
//       if (isEmail) {
//         const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${email}&otp=${code}`);
//         if (res.data.success === "OTP verified successfully.") {
//           localStorage.setItem("isEmailVerified", "true");
//           await checkUserAndNavigate(email);
//         } else {
//           toast.error("Invalid Email OTP");
//         }
//       } else {
//         const payload = encodeRequestData({
//           requestType: "VALIDATE-OTP",
//           msisdn: phone,
//           otpPin: code,
//           otpSessionId: localStorage.getItem("otpSessionId"),
//         });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         if (res.data.status === "SUCCESS") {
//           localStorage.setItem("isOtpVerified", "true");
//           await checkUserAndNavigate(phone);
//         } else {
//           toast.error("Invalid Mobile OTP");
//         }
//       }
//     } catch (e) {
//       toast.error("Verification failed.");
//     }
//   };

//   return (
//     <div className="unified-page-wrapper">
//       <Header />
//       <div className="unified-otp-bg">
//         <div className="otp-modern-card glass-morph">
//           <div className="ab-logo-universe-box">
//             <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
//             <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
//           </div>
//           <h2>Verify Identity</h2>
//           <p className="otp-sent-to">Verifying <span>{isEmail ? email : `+91 ${phone}`}</span></p>
//           <div className="otp-row">
//             {otp.map((d, i) => (
//               <input key={i} ref={(el) => (inputRefs.current[i] = el)} maxLength={1} type="text" inputMode="numeric" value={d}
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/[^0-9]/g, "");
//                   if (!val && e.nativeEvent.inputType !== "deleteContentBackward") return;
//                   const n = [...otp]; n[i] = val; setOtp(n);
//                   if (val && i < otp.length - 1) inputRefs.current[i + 1].focus();
//                 }}
//                 onKeyDown={(e) => { if (e.key === "Backspace" && !otp[i] && i > 0) inputRefs.current[i - 1].focus(); }}
//               />
//             ))}
//           </div>
//           <button className="otp-submit-btn" onClick={handleVerify}>VERIFY & CONTINUE</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnifiedOtpValidate;



// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import APIURL from "../../common/Config";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import Header from "../header/header";
// import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const phone = localStorage.getItem("phoneNumber");
//   const email = localStorage.getItem("userEmail");
//   const isEmail = location.state?.flow === "email";
//   const [otp, setOtp] = useState(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     inputRefs.current[0]?.focus();
//   }, []);

//   const checkUserAndNavigate = async (identity) => {
//     try {
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(identity);
//       if (data && data.id > 0) {
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("userData", JSON.stringify(data));
//         toast.success("Welcome back!");
//         navigate("/");
//       } else {
//         navigate("/signup-who-are-you");
//       }
//     } catch (e) {
//       navigate("/signup-who-are-you");
//     }
//   };

//   const handleVerify = async () => {
//     const code = otp.join("");
//     if (code.length < (isEmail ? 6 : 4)) return toast.error("Please enter full OTP");

//     try {
//       if (isEmail) {
//         const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${email}&otp=${code}`);
//         if (res.data.success.includes("verified")) {
//           localStorage.setItem("isEmailVerified", "true");
//           await checkUserAndNavigate(email);
//         } else {
//           toast.error("Invalid Email OTP");
//         }
//       } else {
//         const payload = encodeRequestData({
//           requestType: "VALIDATE-OTP",
//           msisdn: phone,
//           otpPin: code,
//           otpSessionId: localStorage.getItem("otpSessionId"),
//         });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         if (res.data.status === "SUCCESS") {
//           localStorage.setItem("isOtpVerified", "true");
//           await checkUserAndNavigate(phone);
//         } else {
//           toast.error("Invalid Mobile OTP");
//         }
//       }
//     } catch (e) {
//       toast.error("Verification failed.");
//     }
//   };

//   return (
//     <div className="unified-page-wrapper">
//       <Header />
//       <div className="auth-overlay">
//         {/* Background Elements Added for Cosmic Effect */}
//         <div className="cosmic-nebula"></div>
//         <div className="cosmic-stars"></div>
//         <div className="shooting-star"></div>
//         <div className="shooting-star"></div>

//         <div className="auth-box">
//           <div className="ab-logo-universe-box">
//             <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
//             <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
//           </div>
          
//           <h2 className="step-title-otp">Verify Identity</h2>
//           <p className="otp-sent-info">Verifying <span>{isEmail ? email : `+91 ${phone}`}</span></p>
          
//           <div className="otp-row-cosmic">
//             {otp.map((d, i) => (
//               <input
//                 key={i}
//                 ref={(el) => (inputRefs.current[i] = el)}
//                 maxLength={1}
//                 type="text"
//                 inputMode="numeric"
//                 className="otp-input-cosmic"
//                 value={d}
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/[^0-9]/g, "");
//                   if (!val && e.nativeEvent.inputType !== "deleteContentBackward") return;
//                   const n = [...otp];
//                   n[i] = val;
//                   setOtp(n);
//                   if (val && i < otp.length - 1) inputRefs.current[i + 1].focus();
//                 }}
//                 onKeyDown={(e) => {
//                   if (e.key === "Backspace" && !otp[i] && i > 0) inputRefs.current[i - 1].focus();
//                 }}
//               />
//             ))}
//           </div>
          
//           <button className="m-continue" onClick={handleVerify}>
//             VERIFY & CONTINUE
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnifiedOtpValidate;

// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux"; // Redux Hooks
// import { closeAllModals } from "../../redux/authSlice"; // Redux Action
// import axios from "axios";
// import APIURL from "../../common/Config";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
// import "./UnifiedOtp.css";

// const UnifiedOtpValidate = ({ isOpen, flow, identity, onClose }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const isEmail = flow === "email";
//   const [otp, setOtp] = useState(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
//   const [loading, setLoading] = useState(false);
//   const inputRefs = useRef([]);

//   useEffect(() => {
//     if (isOpen) {
//       // Modal khulte hi pehle input par focus
//       setTimeout(() => {
//         inputRefs.current[0]?.focus();
//       }, 100);
//     }
//   }, [isOpen]);

//   const checkUserAndNavigate = async (userIdentity) => {
//     try {
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
//       if (data && data.id > 0) {
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("userData", JSON.stringify(data));
//         toast.success("Welcome back!");
//         dispatch(closeAllModals()); // Redux Modal band karo
//         navigate("/");
//       } else {
//         dispatch(closeAllModals());
//         navigate("/signup-who-are-you");
//       }
//     } catch (e) {
//       dispatch(closeAllModals());
//       navigate("/signup-who-are-you");
//     }
//   };

//   const handleVerify = async () => {
//     const code = otp.join("");
//     const requiredLength = isEmail ? 6 : 4;
//     if (code.length < requiredLength) return toast.error("Please enter full OTP");

//     // --- MASTER BYPASS LOGIC ---
//     if ((identity === "testerinthehouse@gmail.com" || identity === "7878787878") && code === "1111") {
//       await checkUserAndNavigate(identity);
//       return;
//     }

//     setLoading(true);
//     try {
//       if (isEmail) {
//         const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${identity}&otp=${code}`);
//         if (res.data.success.includes("verified")) {
//           localStorage.setItem("isEmailVerified", "true");
//           await checkUserAndNavigate(identity);
//         } else {
//           toast.error("Invalid Email OTP");
//         }
//       } else {
//         const payload = encodeRequestData({
//           requestType: "VALIDATE-OTP",
//           msisdn: identity,
//           otpPin: code,
//           otpSessionId: localStorage.getItem("otpSessionId"),
//         });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         if (res.data.status === "SUCCESS") {
//           localStorage.setItem("isOtpVerified", "true");
//           await checkUserAndNavigate(identity);
//         } else {
//           toast.error("Invalid Mobile OTP");
//         }
//       }
//     } catch (e) {
//       toast.error("Verification failed.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="auth-overlay">
//       <div className="cosmic-nebula"></div>
//       <div className="cosmic-stars"></div>
//       <div className="shooting-star"></div>
//       <div className="shooting-star"></div>

//       <div className="auth-box">
//         <button className="close-x" onClick={onClose}>&times;</button>
        
//         <div className="ab-logo-universe-box">
//           <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
//           <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
//         </div>

//         <h2 className="step-title-otp">Verify Identity</h2>
//         <p className="otp-sent-info">Verifying <span>{isEmail ? identity : `+91 ${identity}`}</span></p>

//         <div className="otp-row-cosmic">
//           {otp.map((d, i) => (
//             <input
//               key={i}
//               ref={(el) => (inputRefs.current[i] = el)}
//               maxLength={1}
//               type="text"
//               inputMode="numeric"
//               className="otp-input-cosmic"
//               value={d}
//               onChange={(e) => {
//                 const val = e.target.value.replace(/[^0-9]/g, "");
//                 if (!val && e.nativeEvent.inputType !== "deleteContentBackward") return;
//                 const n = [...otp];
//                 n[i] = val;
//                 setOtp(n);
//                 if (val && i < otp.length - 1) inputRefs.current[i + 1].focus();
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "Backspace" && !otp[i] && i > 0) inputRefs.current[i - 1].focus();
//               }}
//             />
//           ))}
//         </div>

//         <button className="m-continue" onClick={handleVerify} disabled={loading}>
//           {loading ? <div className="loader"></div> : "VERIFY & CONTINUE"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UnifiedOtpValidate;

import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; 
import { closeAllModals, switchToSelection } from "../../redux/authSlice"; 
import axios from "axios";
import APIURL from "../../common/Config";
import { encodeRequestData } from "../../utils/apiSecurity";
import toast from "react-hot-toast";
import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
import "./UnifiedOtp.css";

const UnifiedOtpValidate = ({ isOpen, flow, identity, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isEmail = flow === "email";
  const [otp, setOtp] = useState(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
const [timer, setTimer] = useState(59);
const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 100);
    }
  }, [isOpen]);

  useEffect(() => {
  let interval;
  if (isOpen && timer > 0) {
    interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  } else if (timer === 0) {
    setCanResend(true);
  }
  return () => clearInterval(interval);
}, [isOpen, timer]);

const handleResend = async () => {
  setTimer(59);
  setCanResend(false);
  setOtp(isEmail ? ["", "", "", "", "", ""] : ["", "", "", ""]);
  // Re-trigger OTP API
  try {
    if (isEmail) {
      await axios.post(`https://heastro.in/heastro-service/otp/generate-email-otp?email=${identity}`);
    } else {
      const payload = encodeRequestData({ requestType: "SEND-OTP", msisdn: identity, timeStamp: new Date().toISOString() });
      const res = await axios.post(`${APIURL}/otp/service`, payload);
      localStorage.setItem("otpSessionId", res.data.otpSessionId);
    }
    toast.success("OTP Resent Successfully");
  } catch (e) { toast.error("Failed to resend OTP"); }
};
  // const checkUserAndNavigate = async (userIdentity) => {
  //   try {
  //     const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
  //     if (data && data.id > 0) {
  //       localStorage.setItem("isLoggedIn", "true");
  //       localStorage.setItem("userData", JSON.stringify(data));
  //       toast.success("Welcome back!");
  //       dispatch(closeAllModals()); 
  //       navigate("/");
  //     } else {
  //      dispatch(switchToSelection());
  //     }
  //   } catch (e) {
  //     dispatch(switchToSelection());
  //   }
  // };
  // const checkUserAndNavigate = async (userIdentity) => {
  //   try {
  //     const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
  //     if (data && data.id > 0) {
  //       localStorage.setItem("isLoggedIn", "true");
  //       localStorage.setItem("userData", JSON.stringify(data));
        
  //       toast.success("Welcome back!");
        
  //       // 1. Pehle Modals band karo
  //       dispatch(closeAllModals()); 
        
  //       // 2. Route clean karo
  //       navigate("/");

  //       // 3. PAGE REFRESH (Only on Success)
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 500); 

  //     } else {
  //       // Naya user hai toh sirf selection screen (No refresh)
  //       dispatch(switchToSelection());
  //     }
  //   } catch (e) {
  //     dispatch(switchToSelection());
  //   }
  // };
// const checkUserAndNavigate = async (userIdentity) => {
//     try {
//       // 1. Backend se data fetch karo check karne ke liye
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
      
//       if (data && data.id > 0) {
//         // 2. Agar user mil gaya, toh data save karlo par login mat karwao abhi
//         localStorage.setItem("tempUserData", JSON.stringify(data));
//         toast.success("Welcome back!");
//       } else {
//         // Naya user hai toh temp data clear rakho
//         localStorage.removeItem("tempUserData");
//       }

//       // 3. --- MAIN CHANGE: Force Selection Modal ---
//       // Seedha selection modal par bhej do, har baar pucha jayega "Who are you"
//       dispatch(switchToSelection());

//     } catch (e) {
//       // Error case mein bhi selection par hi bhejenge safer side
//       dispatch(switchToSelection());
//     }
//   };
// const checkUserAndNavigate = async (userIdentity) => {
//     try {
//       // Backend se user details mangwao
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
      
//       if (data && data.id > 0) {
//         // --- 100% ACCURATE MAPPING ---
//         // Agar user Email se login kar raha hai, toh uska mobile number fetch karke save karo
//         // Taaki selection screen aur poore app ko "phoneNumber" mil jaye
//         if (data.mobile) {
//           localStorage.setItem("phoneNumber", data.mobile); 
//         }

//         // Data temporary save karo selection step ke liye
//         localStorage.setItem("tempUserData", JSON.stringify(data));
//         toast.success("Welcome back!"); 
//       } else {
//         localStorage.removeItem("tempUserData");
//       }

//       // Har baar selection modal par bhejo
//       dispatch(switchToSelection());

//     } catch (e) {
//       dispatch(switchToSelection());
//     }
//   };
// const checkUserAndNavigate = async (userIdentity) => {
//     console.log("Checking Backend for Identity:", userIdentity); // Debug Log
//     try {
//       // Backend se user details mangwao
//       const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
      
//       console.log("Backend Response Received:", data); // Isse pata chalega data mila ya nahi

//       if (data && data.id > 0) {
//         console.log("User Found! Mapping Mobile:", data.mobile);
        
//         // --- SEAMLESS MAPPING ---
//         if (data.mobile) {
//           localStorage.setItem("phoneNumber", data.mobile); 
//         }

//         // Selection screen ke liye save karo
//         localStorage.setItem("tempUserData", JSON.stringify(data));
//         toast.success("Identity Verified!"); 
//       } else {
//         console.log(" No User Found with this identity. User must register.");
//         localStorage.removeItem("tempUserData");
        
//       }

//       // Selection modal par bhejo
//       dispatch(switchToSelection());

//     } catch (e) {
//       console.error("API Error in checkUserAndNavigate:", e);
//       dispatch(switchToSelection());
//     }
//   };
const checkUserAndNavigate = async (userIdentity) => {
    console.log("Checking Backend for Identity:", userIdentity);
    try {
      const data = await ApiManagerCustomer.fetchCustomerAccountDetails(userIdentity);
      console.log("Backend Response:", data);

      if (data && data.id > 0) {
        // --- EXISTING USER: DIRECT LOGIN ---
        console.log("User Found! Logging in directly...");
        
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userData", JSON.stringify(data));
        if (data.mobile) localStorage.setItem("phoneNumber", data.mobile);
        
        // Cleanup if any temp data exists
        localStorage.removeItem("tempUserData");
        
        toast.success("Welcome back!");
        dispatch(closeAllModals()); // Modals band karo
        
        // Direct refresh to home page
        window.location.href = "/"; 
      } else {
        // --- NEW USER: SEND TO SELECTION ---
        console.log("No User Found. Sending to Selection Page.");
        localStorage.removeItem("tempUserData");
        dispatch(switchToSelection()); // Sirf tabhi selection dikhao jab user naya ho
      }

    } catch (e) {
      console.error("API Error in checkUserAndNavigate:", e);
      // Error par safe side selection dikha do
      dispatch(switchToSelection());
    }
  };

  // const handleVerify = async () => {
  //   const code = otp.join("");
  //   const requiredLength = isEmail ? 6 : 4;
  //   if (code.length < requiredLength) return toast.error("Please enter full OTP");

  //   // --- MASTER BYPASS LOGIC (SET 1111 / 111111) ---
  //   const isMasterEmail = isEmail && identity === "testerinthehouse@gmail.com" && code === "111111";
  //   const isMasterMobile = !isEmail && identity === "9476665340" && code === "1111";

  //   if (isMasterEmail || isMasterMobile) {
  //     toast.success("Master Access Granted!");
  //     await checkUserAndNavigate(identity);
  //     return; 
  //   }

  //   setLoading(true);
  //   try {
  //     if (isEmail) {
  //       const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${identity}&otp=${code}`);
  //       if (res.data.success.includes("verified")) {
  //         localStorage.setItem("isEmailVerified", "true");
  //         await checkUserAndNavigate(identity);
  //       } else {
  //         toast.error("Invalid Email OTP");
  //       }
  //     } else {
  //       const payload = encodeRequestData({
  //         requestType: "VALIDATE-OTP",
  //         msisdn: identity,
  //         otpPin: code,
  //         otpSessionId: localStorage.getItem("otpSessionId"),
  //       });
  //       const res = await axios.post(`${APIURL}/otp/service`, payload);
  //       if (res.data.status === "SUCCESS") {
  //         localStorage.setItem("isOtpVerified", "true");
  //         await checkUserAndNavigate(identity);
  //       } else {
  //         toast.error("Invalid Mobile OTP");
  //       }
  //     }
  //   } catch (e) {
  //     toast.error("Verification failed.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVerify = async () => {
    const code = otp.join("");
    const requiredLength = isEmail ? 6 : 4;
    if (code.length < requiredLength) return toast.error("Please enter full OTP");

    setLoading(true);
    try {
      if (isEmail) {
        const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${identity}&otp=${code}`);
        if (res.data.success.includes("verified")) {
          // Email verify hote hi pehle identity save karo
          localStorage.setItem("userEmail", identity);
          localStorage.setItem("isEmailVerified", "true");
          
          // Turant details fetch karke mobile number set karwayenge
          await checkUserAndNavigate(identity);
        } else {
          toast.error("Invalid Email OTP");
        }
      } else {
        const payload = encodeRequestData({
          requestType: "VALIDATE-OTP",
          msisdn: identity,
          otpPin: code,
          otpSessionId: localStorage.getItem("otpSessionId"),
        });
        const res = await axios.post(`${APIURL}/otp/service`, payload);
        if (res.data.status === "SUCCESS") {
          localStorage.setItem("phoneNumber", identity);
          localStorage.setItem("isOtpVerified", "true");
          await checkUserAndNavigate(identity);
        } else {
          toast.error("Invalid Mobile OTP");
        }
      }
    } catch (e) {
      toast.error("Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="auth-overlay">
      <div className="cosmic-nebula"></div>
      <div className="cosmic-stars"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>

      <div className="auth-box">
        <button className="close-x" onClick={onClose}>&times;</button>
        
        <div className="ab-logo-universe-box">
          <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
          <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
        </div>

        <h2 className="step-title-otp">Verify Identity</h2>
        <p className="otp-sent-info">Verifying <span>{isEmail ? identity : `+91 ${identity}`}</span></p>

        <div className="otp-row-cosmic">
          {otp.map((d, i) => (
            <input
              key={i}
              ref={(el) => (inputRefs.current[i] = el)}
              maxLength={1}
              type="text"
              inputMode="numeric"
              className="otp-input-cosmic"
              value={d}
              onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, "");
                if (!val && e.nativeEvent.inputType !== "deleteContentBackward") return;
                const n = [...otp];
                n[i] = val;
                setOtp(n);
                if (val && i < otp.length - 1) inputRefs.current[i + 1].focus();
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !otp[i] && i > 0) inputRefs.current[i - 1].focus();
              }}
            />
          ))}
        </div>

<div className="resend-container-cosmic">
  {timer > 0 ? (
    <p className="timer-text">Resend in <span>00:{timer < 10 ? `0${timer}` : timer}</span></p>
  ) : (
    <button className="resend-btn-cosmic" onClick={handleResend}>RESEND OTP</button>
  )}
</div>
        <button className="m-continue" onClick={handleVerify} disabled={loading}>
          {loading ? <div className="loader"></div> : "VERIFY & CONTINUE"}
        </button>
      </div>
    </div>
  );
};

export default UnifiedOtpValidate;